import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../../ruta-server/BaseApi";
import "./ControlPeriodo.css"

export function ControlPeriodo(props) {
  const { periodoIR } = props;
  const { auth } = useAuth();

  const addPeriodo = async (data) => {
    try {
      await createPeriodoReinscripcion(data, auth.token);
    } catch (error) {
      throw error;
    }
  };

  const updatePeriodo = async (id, data) => {
    try {
      await updatePeriodoRApi(id, data, auth.token);
    } catch (error) {
      throw error;
    }
  };

  async function createPeriodoReinscripcion(data, token) {
    try {
      const url = `${BASE_API}/api/periodo_reinscripcion/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.post(url, data, { headers });
      toast.success("Fecha guardada exitosamente");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async function updatePeriodoRApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/periodo_reinscripcion/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      toast.success("Actualización exitosa");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(periodoIR),
    validationSchema: Yup.object(periodoIR ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (periodoIR) await updatePeriodo(periodoIR.id_periodo_reinscripcion, formValue);
        else await addPeriodo(formValue);
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <>
    
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <div className="seccion">
        <label>
          Fecha de inicio <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="fecha_inicio"
          type="date"
          placeholder="Clave de la materia"
          value={formik.values.fecha_inicio}
          onChange={formik.handleChange}
          error={formik.errors.fecha_inicio}
        />
        <label>
          Hora <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="hora_inicio"
          type="time"
          placeholder="Nombre materia"
          value={formik.values.hora_inicio}
          onChange={formik.handleChange}
          error={formik.errors.hora_inicio}
        />
        </div>
        <div className="seccion">
        <label>
          Fecha de fin <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="fecha_fin"
          type="date"
          placeholder="Semestre"
          value={formik.values.fecha_fin}
          onChange={formik.handleChange}
          error={formik.errors.fecha_fin}
        />
        <label>
          Hora <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="hora_fin"
          type="time"
          placeholder="Número de unidades"
          value={formik.values.hora_fin}
          onChange={formik.handleChange}
          error={formik.errors.hora_fin}
        />
        </div>
        <Button
          type="submit"
          content={periodoIR ? "Actualizar" : "Guardar"}
          style={{ backgroundColor: "#008e86", color: "white" }}
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosPeriodo) {
  return {
    fecha_inicio: datosPeriodo?.fecha_inicio || "",
    hora_inicio: datosPeriodo?.hora_inicio || "",
    fecha_fin: datosPeriodo?.fecha_fin || "",
    hora_fin: datosPeriodo?.hora_fin || "",
  };
}

function newSchema() {
  return {
    fecha_inicio: Yup.string().required(true),
    hora_inicio: Yup.string().required(true),
    fecha_fin: Yup.string().required(true),
    hora_fin: Yup.string().required(true),
  };
}
function updateSquema() {
  return {
    fecha_inicio: Yup.string().required(true),
    hora_inicio: Yup.string().required(true),
    fecha_fin: Yup.string().required(true),
    hora_fin: Yup.string().required(true),
  };
}
